<template>
    <div id="box-tour-request" :class="['container-fluid text-center py-2 box-fixed box-white', (showAlert || errorMsg !== '') ? '' : 'd-none']">

        <h3 class="text-center my-3">Book your guided tour of the Booth</h3>

        <p v-if="!requestSent && !toursOutput && errorMsg == ''" class="text-center"><strong>Are you sure you want to book your place on desired slot?</strong></p>

        <p v-if="errorMsg !== ''" class="text-center alert alert-warning mx-4">
            <strong><i class="fa fa-exclamation-circle me-2"></i> {{ errorMsg }}</strong>
        </p>

        <p v-if="toursOutput && !requestSent && errorMsg == ''" class="text-center alert alert-warning mx-4">
            <strong><i class="fa fa-exclamation-circle me-2"></i> You already reserved a tour! <br />
            Please, delete your request before continuing.</strong>
        </p>

        <p v-if="requestSent" class="text-center alert alert-info mx-4"><strong><i class="fa fa-info-circle me-2"></i> Booking reserved correctly!</strong></p>

        <button type="button" class="btn btn-secondary me-3" @click="hidePopup">
            <span v-if="requestSent">Close</span>
            <span v-if="!requestSent">Cancel</span>
            <i class="fa fa-times"></i>
        </button>

        <button type="button" v-if="!requestSent" :class="[(!btnEnabled) ? 'disabled' : '', 'btn btn-coesia']" @click="sendRequest">
            Send Booking request
            <i class="far fa-paper-plane" v-if="btnEnabled"></i>
            <i class="fa fa-times" v-if="!btnEnabled"></i>
        </button>
    </div>

    <div v-if="pageItem" class="gx-0">
        <div class="text-center" v-if="pageItem.image">
            <img :src="`${publicPath}`+ pageItem.image" v-bind:alt="pageItem.title" class="img-fluid" data-fancybox="gallery" />
        </div>
    </div>

    <div v-if="pageItem" class="col">
        <h2 :class="(!pageItem.text) ? 'text-center' : ''">{{ pageItem.title }}</h2>
        <h3 v-if="pageItem.subtitle" class="mb-4">{{ pageItem.subtitle }}</h3>
        <div id="page-text" v-html="pageItem.text"></div>

        <div v-if="toursOutput" class="my-3">
            <h3>Your reserved tour</h3>
            <div class="d-flex w-100 justify-content-between">
                <span>{{ toursOutput.title }} at {{ toursOutput.time }}</span>
                <span><a href="#" @click="clearRequest">Cancel <i class="fa fa-trash ms-2"></i></a></span>
            </div>
        </div>
    </div>

</template>

<script>
    import axios from 'axios'
    import baseStore from '../../store/index'

    export default {
        name: 'EventPage',
        props: ['pageItem'],
        data() {
            return {
                publicPath: process.env.BASE_URL,
                showAlert: false,
                btnEnabled: true,
                errorMsg: "",
                requestSent: false,
                requestData: null,
                toursOutput: null
            }
        },
        computed: {
            user() {
                return this.$store.getters.user;
            },
            requestResult() {
                return this.$store.getters.requestResult;
            },
        },
        mounted() {
            // check tours reservation
            const table = document.getElementById("table-tours")
            if (table) this.getReservedTour()
            // bind button tours reservation
            const btns = document.querySelectorAll(".ajax");
            btns.forEach(btn => btn.addEventListener('click', this.showPopup))
        },
        watch: {
            requestResult() {
                return this.$store.getters.requestResult;
            },
        },
        methods: {
            getReservedTour() {
                console.log("getReservedTour - user loaded: ", this.user)
                if (this.user && this.user.tours) {
                    this.btnEnabled = false
                    this.toursOutput = this.user.tours[0]
                    this.toursOutput.userId = this.user.id
                    //console.log(this.toursOutput)
                }
            },
            showPopup(e) {
                e.preventDefault()
                this.requestData = e.target.dataset
                this.requestData.userid = this.user.id
                this.errorMsg = ""
                this.showAlert = true
                this.requestSent = false
                if (!this.toursOutput) this.btnEnabled = true
            },
            hidePopup(e) {
                e.preventDefault()
                this.errorMsg = ""
                this.showAlert = false
            },
            sendRequest(e) {
                e.preventDefault()
                console.log('partecipate => data: ', this.requestData)
                const token = localStorage.getItem("token");
                if (!baseStore.getters.offlineMode) {
                    axios
                        .post(baseStore.getters.apiPath + 'partecipate', this.requestData, {
                            headers: {
                                'Authorization': `JWT ${token}`
                            }
                        }
                        )
                        .then((response) => {
                            this.btnEnabled = false
                            if (response.data.error) {
                                this.errorMsg = response.data.error
                            } else {
                                this.requestSent = true
                                this.$store.dispatch('updateTourRequest', response)
                                this.user = this.$store.getters.user
                                this.getReservedTour()
                            }
                        })
                        .catch((error) => {
                            this.errorMsg = error
                            console.log("GET call unsuccessful :(", error);
                        });
                }
            },
            clearRequest(e) {
                e.preventDefault()
                var confirm = window.confirm("Are you sure that you want to delete your booking request?");
                if (confirm) {
                    console.log('clearRequest => data: ', this.toursOutput)
                    const token = localStorage.getItem("token");
                    if (!baseStore.getters.offlineMode) {
                        axios
                            .post(baseStore.getters.apiPath + 'delpartecipate', this.toursOutput, {
                                headers: {
                                    'Authorization': `JWT ${token}`
                                }
                            }
                            )
                            .then((response) => {
                                if (response.data.error) {
                                    this.btnEnabled = false
                                    this.errorMsg = response.data.error
                                } else {
                                    this.btnEnabled = true
                                    this.toursOutput = null
                                    this.$store.dispatch('updateTourRequest', response)
                                }
                            })
                            .catch((error) => {
                                this.errorMsg = error
                                console.log("GET call unsuccessful :(", error);
                            });
                    }
                }
            }
        }
    }
</script>
